import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { BookOpenIcon, ClockIcon, UsersIcon, TargetIcon } from 'lucide-react';
export function ProductReveal() {
  return <SectionWrapper className="bg-cream py-20" constrained={false} data-id="element-233">
      <div className="max-w-4xl mx-auto px-6" data-id="element-234">
        <div className="text-center mb-12" data-id="element-235">
          <p className="font-sans text-sm font-bold tracking-widest text-coral uppercase mb-4" data-id="element-236">
            Presentamos
          </p>
          <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold text-ink mb-6" data-id="element-237">
            PROTOCOLO CALMA 3 MINUTOS
          </h2>
          <p className="font-sans text-xl md:text-2xl text-ink-mid max-w-2xl mx-auto font-medium" data-id="element-238">
            La guía táctica para detener berrinches y crisis emocionales sin
            gritar, sin amenazas y sin perder los nervios
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-239">
          <div className="bg-white p-6 rounded-xl flex items-start gap-4 shadow-soft border border-hairline" data-id="element-240">
            <BookOpenIcon className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-241" />
            <div data-id="element-242">
              <h4 className="font-sans font-bold text-ink mb-1" data-id="element-243">Formato</h4>
              <p className="font-sans text-ink-mid" data-id="element-244">
                PDF descargable de implementación inmediata
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl flex items-start gap-4 shadow-soft border border-hairline" data-id="element-245">
            <UsersIcon className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-246" />
            <div data-id="element-247">
              <h4 className="font-sans font-bold text-ink mb-1" data-id="element-248">Para</h4>
              <p className="font-sans text-ink-mid" data-id="element-249">
                Madres, padres y cuidadores de niños de 2 a 7 años
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl flex items-start gap-4 shadow-soft border border-hairline" data-id="element-250">
            <ClockIcon className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-251" />
            <div data-id="element-252">
              <h4 className="font-sans font-bold text-ink mb-1" data-id="element-253">
                Tiempo de lectura
              </h4>
              <p className="font-sans text-ink-mid" data-id="element-254">90 minutos o menos</p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl flex items-start gap-4 shadow-soft border border-hairline" data-id="element-255">
            <TargetIcon className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-256" />
            <div data-id="element-257">
              <h4 className="font-sans font-bold text-ink mb-1" data-id="element-258">Resultado</h4>
              <p className="font-sans text-ink-mid" data-id="element-259">
                Una intervención clara, paso a paso, para aplicar en la próxima
                crisis
              </p>
            </div>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto space-y-4 font-sans text-lg text-ink-mid" data-id="element-260">
          <p className="font-bold text-ink" data-id="element-261">
            Este no es un libro de teoría de crianza.
          </p>
          <p data-id="element-262">No te va a pedir que hagas un máster en psicología infantil.</p>
          <p data-id="element-263">No tiene 300 páginas de conceptos abstractos.</p>
          <p className="text-2xl text-coral font-bold mt-8 mb-4" data-id="element-264">
            Es una guía táctica.
          </p>
          <p className="italic" data-id="element-265">
            Diseñada para que la leas en una tarde y la apliques esa misma
            noche.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}